import React, { useMemo, useState } from 'react';
import cx from 'classnames';
import { ParentSize } from '@visx/responsive';

import BriefingItemChartPlot from './BriefingItemChartPlot';
import LegendSwatch from './LegendSwatch';
import {
  briefingLegendItems,
  buildLines,
  titleCaseCaption,
} from './briefing-chart-lines';
import styles from './BriefingItemChart.module.scss';

export default function BriefingItemChart({
  chart,
  paletteById = {},
  margins,
}) {
  const { lines } = useMemo(() => buildLines(chart?.lines ?? []), [chart]);
  const cycleCount = lines.reduce(
    (max, line) => Math.max(max, line.points.length),
    0
  );
  const [hoveredLineId, setHoveredLineId] = useState(null);

  if (!chart || lines.length === 0 || cycleCount === 0) {
    return null;
  }

  return (
    <figure data-test="briefing-item-chart">
      <div className={styles.itemChartCanvas}>
        <ParentSize debounceTime={10} className={styles.itemChartParent}>
          {({ width, height }) =>
            width > 0 && height > 0 ? (
              <BriefingItemChartPlot
                chart={chart}
                paletteById={paletteById}
                width={width}
                height={height}
                margins={margins}
                hoveredLineId={hoveredLineId}
                onHoveredLineId={setHoveredLineId}
              />
            ) : null
          }
        </ParentSize>
      </div>
      <div className={styles.itemChartLegend} data-chart-legend="">
        {briefingLegendItems(lines, chart.kind, paletteById).map((item) => {
          const isHovered =
            item.highlightsOnHover &&
            hoveredLineId &&
            item.ids[0] === hoveredLineId;

          return (
            <span
              key={item.key}
              className={cx(styles.itemChartLegendItem, {
                [styles.itemChartLegendItemActive]: isHovered,
              })}
            >
              <LegendSwatch
                dashed={item.visual.dashed}
                paletteClassName={item.visual.paletteClassName}
                dotClassName={styles.itemChartLegendDot}
              />
              <span data-chart-legend-label="">{item.label}</span>
            </span>
          );
        })}
      </div>
      {chart.title ? (
        <figcaption>{titleCaseCaption(chart.title)}</figcaption>
      ) : null}
    </figure>
  );
}
